import axios from 'axios';

const API_URL = 'http://137.74.92.81:3098';

export interface IUserScore {
    time: number;
    level: number;
}

export async function getUserScores(userId: number, gameId: number): Promise<IUserScore[]> {
    const url = API_URL + '/getUserScores';
    const postData = {userId, gameId};
    const data = await axios.post(url, postData);
    return data.data as IUserScore[];
}